export default function(path, values) {
  return Object.keys(values).reduce((p, key) => p.replace(`:${key}`, values[key]), path);
}
